import React, { useEffect, useState } from 'react';
import { useClickStreamContext } from '../shared/ClickStream';
import Spacer from '../shared/Spacer';
import { Container, Header, NumberElement, Text } from 'features/shared/ui/Page';
import { Space } from '@gr-monorepo/common/ui';
import { Header24h34, NumberText, Statistics, StatisticsItem, PlateStyled } from './styles';
import pluralize from 'utils/pluralize';
import { useBannersContext } from 'features/shared/Banners/BannersContext';
import Banners from 'features/shared/Banners/Banners';
import CourseTemplate from './CourseTemplate';
import Advantages from './Advantage';
import { useCourses } from './useCourses';

const Courses = () => {
  const { banners } = useBannersContext({ section: 'kpk' });
  const { courses, pending } = useCourses();
  return (
    <Container>
      <Header>Курсы повышения квалификации</Header>
      <Space axis="vertical" size={24} />
      <Text style={{ paddingLeft: 24, paddingRight: 50 }}>
        Курсы повышения квалификации Учи.ру помогают учителям получать ценные навыки и осваивать полезные инструменты.
        С их помощью педагоги могут увлекательно преподносить сложный материал, находить подход к разным ученикам
        и вдохновлять детей заниматься усерднее. При успешном прохождении обучения выдаётся удостоверение о повышении
        квалификации, зарегистрированное в Федеральном реестре документов об образовании.
      </Text>
      <Space axis="vertical" size={24} />
      <PlateStyled>
        <Header24h34>Преимущества</Header24h34>
        <Spacer size={32} />
        <Advantages />
      </PlateStyled>
      <Spacer size={40} />
      {banners.length ? (
        <>
          <Banners section="kpk" />
          <Spacer size={32} />
        </>
      ) : null}
      <Header24h34 style={{ paddingLeft: 24 }}>Наши курсы</Header24h34>
      <Spacer size={24} />
      {courses.map((el, i, arr) => {
        return (
          <>
            <CourseTemplate {...el} key={el.id} />
            {arr.length > i + 1 && <Spacer size={40} />}
          </>
        );
      })}
    </Container>
  );
};

export default Courses;
